//顶部导航条组件
<template>
  <div class="top_nav">
    <!-- LOGO -->
    <div class="logo">
      <a :href="cmgos">
        <img :src="logo" alt="logo">
      </a>
    </div>
    <!-- 链接 -->
    <ul class="main_nav">
      <li v-for="(item, index) in nav"
          @mouseover="showUl(index)" :key="index"
          @mouseleave="hideUl(index)"
      >
        <a v-if="item.miniNav.length > 1" href="javascript:">
          <span class="name" :class="{ active : item.active}">{{item.name}}
          <i class="el-icon-arrow-down" style="font-size: 8px;"></i>
          </span>
        </a>
        <transition name="slide-fade" v-if="item.miniNav.length > 1">
          <ul v-if="item.isShow">
            <li v-for="item in item.miniNav" :key="item.index">
              <a :href="item.link">{{item.name}}</a>
            </li>
          </ul>
        </transition>
        <a v-if="item.miniNav.length === 1" :href="item.miniNav[0].link">
          <span class="name" :class="{ active : item.active}">
            {{item.name}}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import {navList} from '@/util/public';
export default {
  name: 'top-nav',
  data () {
    return {
      logo: '/static/img/logo.png',
      cmgos: 'http://www.cmgos.com/',
      nav: navList
    }
  },
  methods: {
    showUl: function(index) {
      return this.nav[index].isShow = true;
    },
    hideUl: function(index) {
      return this.nav[index].isShow = false;
    },
  }
}
</script>

<!-- 组件的样式不复用 -->
<style scoped lang="scss">
@import '~@/style/base/constant';
@import '~@/style/components/top_nav';
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue